var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1320_217",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 11
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0678711,
    y: 0.683594,
    width: 10,
    height: 10,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1320_217)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3758 8.02382C5.20574 8.19388 4.93001 8.19388 4.75994 8.02382L0.695423 3.9593C0.525355 3.78923 0.525355 3.5135 0.695423 3.34343C0.865489 3.17337 1.14122 3.17337 1.31129 3.34343L5.06787 7.10002L8.82445 3.34343C8.99452 3.17337 9.27025 3.17337 9.44032 3.34343C9.61039 3.5135 9.61039 3.78923 9.44032 3.9593L5.3758 8.02382Z",
    fill: "#101010"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrow);
export default __webpack_public_path__ + "static/media/sort_arrow.52a9307d8fb04f7760fcd38c393b3beb.svg";
export { ForwardRef as ReactComponent };